'use client';
import { useEffect, useState } from 'react';
import style from './style.module.scss';
import Image from 'next/image';
import tgLogo from '@/public/tg-logo.png';
import Link from 'next/link';
import dayjs from 'dayjs';

type Message = {
  id: number;
  text: string;
  date: string;
  images?: string[]; // Поле для изображений
  videos?: string[]; // Поле для видео
};

export const TgWidget = () => {
  const [messages, setMessages] = useState<Message[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchMessages = async () => {
      try {
        const res = await fetch(`/api/tg-posts`, { cache: 'no-cache' });
        const data = await res.json();

        if (data.messages) {
          setMessages(data.messages);
        }
      } catch (error) {
        console.error('Ошибка при запросе:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchMessages();
  }, []);

  return (
    <div className={style.wrapper}>
      <div className={style.icon}>
        <Link target="_blank" href={'https://t.me/emita_net'}>
          <Image src={tgLogo} width={65} height={65} alt="tg-logo" />
        </Link>
      </div>
      <div className={style.widget}>
        <div>
          {loading ? (
            <p>Загрузка...</p>
          ) : (
            <ul>
              {messages.length > 0 ? (
                messages.reverse().map((message) => (
                  <li className={style.item} key={message.id}>
                    {/* Отображение изображений */}
                    <div className={style.top}>
                      <p className={style.title}>ЭМИТА | Многополярная аналитика</p>
                      {/* @ts-ignore */}
                      <p>{dayjs(message?.date * 1000).format('DD.MM.YYYY')}</p>
                      {/* <p>{message.date}</p> */}
                    </div>
                    {message.images && message.images.length > 0 && (
                      <div className={style.mediaWrapper}>
                        {message.images.map((img, index) => (
                          <Image
                            key={index}
                            src={img}
                            alt={`Image ${index}`}
                            width={340}
                            height={200}
                            className={style.image}
                          />
                        ))}
                      </div>
                    )}
                    {/* <p className={style.message}>{message.text}</p> */}
                    <p
                      dangerouslySetInnerHTML={{
                        __html: message.text.replace(/\n/g, '<br>').replace('🗣ПОДПИСЫВАЙТЕСЬ', ''),
                      }}
                    />

                    {/* Отображение видео */}
                    {message.videos && message.videos.length > 0 && (
                      <div className={style.mediaWrapper}>
                        {message.videos.map((video, index) => (
                          <video
                            key={index}
                            controls
                            width={340}
                            height={200}
                            className={style.video}>
                            <source src={video} type="video/mp4" />
                            Ваш браузер не поддерживает видео.
                          </video>
                        ))}
                      </div>
                    )}
                  </li>
                ))
              ) : (
                <li>Нет сообщений</li>
              )}
            </ul>
          )}
        </div>
      </div>
      <div className={style.bottom_text}>
        <Link href={'https://t.me/emita_net'} target="_blank">
          Перейти
        </Link>
      </div>
    </div>
  );
};
